import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Accordion, Card } from 'react-bootstrap';
import ButtonCompontent from './ActionComponent';
import { addProductGroup, fetchProductGroup } from '../Store/SystemMasters.action';
// eslint-disable-next-line import/no-cycle
import CardContent from './CardContent';
import { Context } from './ContextWrapper';
import Loader from '../../../Components/Utility/Loader/Loader';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function ProductGroupMaster() {
  const { addNewItem, cards, updateSubmitState, formState, setFormState, MasterAddEditAccess, OpenReArrangeFunction } = useContext(Context);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const [openCard, setOpenCard] = useState(false);

  const switchCardState = () => {
    setOpenCard((prev) => !prev);
  };

  const handleClick = async () => {
    try {
      if (cards?.length > 0) {
        setFormState((otherData) => ({ ...otherData, isLoading: true }));
        updateSubmitState(true);
        if (Object.keys(formState?.errors)?.length) {
          setFormState((otherData) => ({ ...otherData, isLoading: false }));
          return;
        }
        const ew = cards.map((obj) => {
          if (obj._id.includes('_id')) {
            return { ...obj, _id: '' };
          }
          return obj;
        });

        const objData = {
          names: JSON.stringify(ew),
          section: 'masters',
          module: 'productGroups',
          action: 'addEdit',
        };

        await dispatch(addProductGroup(objData, t));
        await dispatch(fetchProductGroup(t));
        updateSubmitState(false);
        setFormState((otherData) => ({ ...otherData, isLoading: false }));
      }
    } catch (error) {}
  };
  return (
    <Accordion className="mb-4 master-accordian">
      <Card>
        <Card.Header>
          <div className="title-container">
            <p>{t('PRODUCT_GROUP_MASTER.PRODUCT_GROUP')}</p>
          </div>
          <div className="action-title-btns">
            {MasterAddEditAccess && (
              <button
                type="button"
                onClick={() => OpenReArrangeFunction('ProductGroup')}
                className="filter-btn filter-button_add"
                disabled={formState?.isLoading || formState?.disableBtn}
                aria-label="Rearrange"
                title={t('PRODUCT_GROUP_MASTER.REARRANGE')}
              >
                <span className="icon-expand" />
              </button>
            )}
            {MasterAddEditAccess && (
              <ButtonCompontent
                icon="icon-add"
                isDisabled={formState?.disableBtn || formState?.isLoading}
                tooltipText={t('PRODUCT_GROUP_MASTER.ADD')}
                show
                onClick={addNewItem}
              />
            )}
            <ButtonCompontent
              icon={openCard ? 'icon-new-up' : 'icon-new-down'}
              isDisabled={false}
              tooltipText={openCard ? t('PRODUCT_GROUP_MASTER.CLOSE') : t('PRODUCT_GROUP_MASTER.OPEN')}
              show
              onClick={switchCardState}
            />
          </div>
        </Card.Header>
        {openCard ? (
          <Card.Body>
            {formState?.isLoading ? (
              <Loader />
            ) : (
              <>
                <CardContent MasterAddEditAccess={MasterAddEditAccess} />
                {MasterAddEditAccess && (
                  <div className="section-save">
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button className="btn btn-page-filter btn-white ml-auto" type="submit" onClick={handleClick} aria-label="Save">
                        <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_GROUP_MASTER.SAVE')}
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </>
            )}
          </Card.Body>
        ) : null}
      </Card>
    </Accordion>
  );
}

export default ProductGroupMaster;
